export const REDUCER_KEY_RS_DRAW_STRUCTURE = 'rsDrawStructure';
export const DRAW_STRUCTURE_SET_EDITOR_TYPE = 'rs/DRAW_STRUCTURE_SET_EDITOR_TYPE';
export const DRAW_STRUCTURE_SET_LOADING = 'rs/DRAW_STRUCTURE_SET_LOADING';
